import * as React from "react";
const SvgFiRrModule = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-module_svg__a)">
      <path
        fill="#062147"
        d="M15.98 7.136c.003.05.02.099.02.15v.715a1 1 0 1 0 2 0v-.714a5.01 5.01 0 0 0-2.52-4.341l-4-2.286a5.02 5.02 0 0 0-4.962 0L2.519 2.945A5.01 5.01 0 0 0 0 7.287v6.344a5.02 5.02 0 0 0 2.452 4.302l4 2.369A5 5 0 0 0 9 21a1 1 0 0 0 1-1v-9.43zM3.511 4.682l4-2.286a3.02 3.02 0 0 1 2.978 0l4 2.286c.276.158.508.365.716.593L8.984 8.848 2.768 5.312c.214-.243.455-.465.744-.63zm3.96 13.899-4-2.37A3.01 3.01 0 0 1 2 13.632V7.287c0-.035.013-.068.014-.102L8 10.59v8.239a3 3 0 0 1-.529-.248zm15.793.798-.983-.566c.129-.418.218-.853.218-1.313s-.09-.895-.218-1.313l.983-.566a1 1 0 1 0-.998-1.733l-.977.563A4.48 4.48 0 0 0 19 13.12V12a1 1 0 1 0-2 0v1.12a4.5 4.5 0 0 0-2.289 1.33l-.977-.562a1 1 0 1 0-.998 1.733l.983.566a4.4 4.4 0 0 0-.218 1.313c0 .46.09.895.218 1.313l-.983.566a1 1 0 1 0 .998 1.732l.977-.563A4.48 4.48 0 0 0 17 21.878v1.12a1 1 0 1 0 2 0v-1.12a4.5 4.5 0 0 0 2.289-1.33l.977.563a1 1 0 1 0 .998-1.732m-5.265.62a2.503 2.503 0 0 1-2.5-2.5c0-1.377 1.121-2.5 2.5-2.5s2.5 1.123 2.5 2.5c0 1.379-1.121 2.5-2.5 2.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-module_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrModule;
